//入账
export const SEARCH_TYPE_ENTRY = 1;
//出账
export const SEARCH_TYPE_WITHDRAWAL = 2;
//订单搜索
export const SEARCH_TYPE_ORDER = 3;
//全部
export const SEARCH_TYPE_ALL = 4;
